import script from "./SummonLegend.vue?vue&type=script&setup=true&lang=js"
export * from "./SummonLegend.vue?vue&type=script&setup=true&lang=js"

import "./SummonLegend.vue?vue&type=style&index=0&id=28a5e5a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28a5e5a8"]])

export default __exports__